exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.small.modal.transition.visible.active {\n  opacity: 0;\n  transition: 0.5s all; }\n  .ui.small.modal.transition.visible.active.ready {\n    opacity: 1; }\n  .ui.small.modal.transition.visible.active .actions {\n    position: absolute;\n    width: 100%;\n    bottom: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/molecules/SgrModal/SgrModal.scss
// module id = 1377
// module chunks = 0